import React from 'react';
import { ScrollView, View } from 'react-native';

import { font as initialFont } from '@styles/fonts';
import { scale as initialScale } from '@components/frame';
import { SCREEN_PADDING_HORIZONTAL } from '@v2/pages/common/constants/base.constants';

import FilterTile from './FilterTile';
import { NC_FILES } from '@components/search/components/statistic/config';
import { formatODataFilter } from '@components/search/components/statistic/helpers';
import { NcFileStatusFiltersProps } from './types';
import { parseFacetsToStorage, calculateElementWidth } from './helpers';

const NcFileStatusFilters: React.FC<NcFileStatusFiltersProps> = ({
  scale = initialScale,
  font = initialFont,
  C,
  facets,
  facetsLoaded,
  selectedFilter,
  onFilterChange,
  style,
  containerMarginBottom,
  availableWidth,
  oDataFilter,
}) => {
  const facetsStorage = parseFacetsToStorage(facets);
  const filters = NC_FILES({ facetsStorage, oDataFilter: formatODataFilter(oDataFilter) });

  const gap = scale(9);
  const elementWidth = calculateElementWidth({
    filtersCount: filters.length,
    gap,
    style,
    availableWidth,
    scale,
  });

  const handleTilePress = (filterName: string, tileODataFilter: string) => {
    if (selectedFilter === filterName) {
      onFilterChange(null, oDataFilter || null);
    } else {
      onFilterChange(filterName, tileODataFilter);
    }
  };

  return (
    <View style={{ marginBottom: containerMarginBottom ?? scale(18) }}>
      <ScrollView horizontal showsHorizontalScrollIndicator={false}>
        <View
          style={[
            {
              flexDirection: 'row',
              gap: scale(9),
              paddingHorizontal: scale(SCREEN_PADDING_HORIZONTAL),
              justifyContent: 'space-between',
            },
            style,
            { width: 'auto' },
          ]}
        >
          {filters.map((filter) => (
            <FilterTile
              key={filter.name}
              name={filter.name}
              value={filter.value}
              icon={filter.icon}
              isSelected={selectedFilter === filter.name}
              hasActiveSelection={!!selectedFilter}
              loaded={facetsLoaded}
              onPress={() => handleTilePress(filter.name, filter.params.oDataFilter)}
              C={C}
              scale={scale}
              font={font}
              elementWidth={elementWidth}
            />
          ))}
        </View>
      </ScrollView>
    </View>
  );
};

export default NcFileStatusFilters;
